module.exports = "https://stanwinstonschool.com/school-our-history-mobile.836b2b8bc697adb97dc4061442c3d409.png";